/**
 * Skeleton — the app's shared loading-shimmer block (2026-07-15, Paul's
 * "kill the doubt-words" ruling).
 *
 * Replaces bare text placeholders ("Checking…", "Loading chart…",
 * "Loading your wealth picture…") on the dashboard with shaped shimmer
 * blocks matching the final layout — a placeholder that mirrors the shape of
 * what's coming reads as intentional; "Checking…" reads as the system
 * doubting itself.
 *
 * Pure presentation: token-driven light-theme shimmer (see skeleton.css),
 * `aria-hidden` (the CONTAINER should carry `aria-busy` / a polite label —
 * screen-reader users get one announcement, not N shimmering rectangles).
 * MEASURED CONTEXT: warm backend clears these in ~600-850ms; the cold path is
 * what these blocks (plus the auth-time prefetch) are for.
 */

import './skeleton.css';

export interface SkeletonProps {
  /** CSS width (number → px). */
  width?: number | string;
  /** CSS height (number → px). */
  height?: number | string;
  /** Border radius override (number → px) — e.g. '50%' for a donut/avatar. */
  radius?: number | string;
  style?: React.CSSProperties;
  testId?: string;
}

export function Skeleton({ width, height, radius, style, testId }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className="ui-skeleton"
      data-testid={testId}
      style={{
        ...(width !== undefined ? { width } : {}),
        ...(height !== undefined ? { height } : {}),
        ...(radius !== undefined ? { borderRadius: radius } : {}),
        ...style,
      }}
    />
  );
}
